// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AppSchema } from './v1/appSchema';

export const listAppsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description List of apps
 */
export const listApps200Schema = z.array(z.lazy(() => v1AppSchema));

export const listAppsQueryResponseSchema = z.lazy(() => listApps200Schema);
